import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { fetchReasonTableAndFilterSchema } from "model/ReasonModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";


const ReasonContext = createContext();

export const ReasonProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [reasonContextData, setReasonContextData] = useState();

  const fetchReasonContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:reason", () =>
        fetchReasonTableAndFilterSchema([])
      );
      if (response?.success) {
        setReasonContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };



    // 🔹 Fetch home page data once

    useEffect(() => {
        const fetchAll = async () => {
            await Promise.all([]);
        };
        fetchAll();
    }, []);

    return (
        <ReasonContext.Provider value={{ fetchReasonContextData, reasonContextData, loading, error }}>
            {children}
        </ReasonContext.Provider>
    );
};

export const useReasonContext = () => useContext(ReasonContext);
